import React, { useCallback, useState, useRef } from 'react';
import { motion } from 'framer-motion';

import { ChevronLeft, ChevronRight } from './Chevrons';
import { SectionHeader } from './SectionHeader';

import useLottieAnimation from '../hooks/useLottieAnimation';
import useInterval from '../hooks/useInterval';

import stickers from '../stikers/index';

import './styles.css';

const lottieAnimations = stickers;

const LottieCarouselDownload: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const autoSwitchRef = useRef<boolean>(true);
  const animationContainer = useLottieAnimation(
    lottieAnimations[currentIndex].jsonFile
  );

  const handleNext = useCallback(() => {
    setCurrentIndex((currentIndex + 1) % lottieAnimations.length);
    autoSwitchRef.current = false;
  }, [currentIndex]);

  const handlePrevious = useCallback(() => {
    setCurrentIndex(
      (currentIndex - 1 + lottieAnimations.length) %
        lottieAnimations.length
    );
    autoSwitchRef.current = false;
  }, [currentIndex]);

  useInterval(() => {
    if (autoSwitchRef.current) {
      setCurrentIndex(
        (prevIndex) => (prevIndex + 1) % lottieAnimations.length
      );
    }
  }, 5000);

  return (
    <div className="container">
      <div className="header-wrapper">
        <SectionHeader />
      </div>

      <div className="carocell-wrapper">
        <motion.div
          className="chavron-left-wrapper"
          onClick={handlePrevious}
        >
          <ChevronLeft height={68} width={57} />
        </motion.div>
        <motion.div>
          <motion.div ref={animationContainer} className="sticker" />
        </motion.div>
        <motion.div
          className="chavron-right-wrapper"
          onClick={handleNext}
        >
          <ChevronRight height={69} width={57} />
        </motion.div>
      </div>
    </div>
  );
};

export default LottieCarouselDownload;
